import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import {
  apiSlice,
  adminApiSlice,
  appSlice,
  authSlice,
  trainingRequestSlice,
  adminAuthSlice
} from './slices';

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  [adminApiSlice.reducerPath]: adminApiSlice.reducer,
  [authSlice.reducerPath]: authSlice.reducer,
  [appSlice.reducerPath]: appSlice.reducer,
  [trainingRequestSlice.reducerPath]: trainingRequestSlice.reducer,
  [adminAuthSlice.reducerPath]: adminAuthSlice.reducer
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([
    apiSlice.middleware,
    adminApiSlice.middleware
  ])
});

setupListeners(store.dispatch);

export default store;
